<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span>{{title}}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{iconname}}</mat-icon>
    </h1>
    <div class="scroll" fxFlex.gt-sm="auto">
        <div [innerHTML]="message | safeHTML"></div>
        <mat-form-field>
            <textarea matInput [(ngModel)]="note" aria-label="Text entry space" placeholder="Enter text here..."></textarea>
        </mat-form-field>
        <!-- <j-md-richtext id="NoteTextBox" ng-model="OptionalNote" aria-label="Optional note body"></j-md-richtext> -->    
    </div>
    <div class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
        <button mat-raised-button color="primary" (click)="OKHandler()" [disabled]="!note">{{oktext}}</button>
        <button mat-raised-button color="warn" (click)="CancelHandler()">{{canceltext}}</button>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/textnote/textnote.dialogcomponent.html